import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftSetUp } from '../ShiftSetUp/ShiftSetUp';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'SkillList',
    templateUrl: './SkillList.html',
})

export class SkillList extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    DeptId: number;
    PropertyID: number;
    SkillList: Array<any>;
    AllSkillSelected: boolean;
    SkillCount: number;
    DisableModalOpenEvent: boolean = false;
    StaffName: string;

    @Output() SkillUpdate: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);
    }
    ngOnInit(): void {
        this.PropertyID = this.masterService.ActivePropertyID;

    }

    Open(Skills, StaffName): void {
        if (this.DisableModalOpenEvent) return;
        this.SkillCount = 0;
        this.StaffName = StaffName;
        this.SkillList = this.shiftSetUp.skillList;
        this.SkillList = this.SkillList.map((row) => {
            if (Skills.indexOf(row.Id) != -1) {
                row.Selected = true;
                this.SkillCount++;
            }
            else
                row.Selected = false;
            return row;
        })
        if (this.SkillCount == this.SkillList.length)
            this.AllSkillSelected = true;
        else
            this.AllSkillSelected = false;

        this.ModalRef = this.modalService.open(this.content, { centered: true, backdrop:'static' });
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    SelectAll(event: boolean): void {
        if (event) {
            for (var i = 0; i < this.SkillList.length; i++) {
                this.SkillList[i].Selected = true;               
            }
            this.SkillCount = this.SkillList.length;
        }
        else {
            for (var i = 0; i < this.SkillList.length; i++) {
                this.SkillList[i].Selected = false;               
            }
            this.SkillCount = 0;
        }
    }

    AddSkill(event: any, index): void {
        if (event.target.checked) {
            this.SkillList[index].Selected = true;
            this.SkillCount++;
        }
        else {
            this.SkillList[index].Selected = false; 
            this.SkillCount--;
        }
        if (this.SkillCount == this.SkillList.length)
            this.AllSkillSelected = true;
        else
            this.AllSkillSelected = false;
    }

    SaveSkill() {
        let SkillIds = [];
        for (let i = 0; i < this.SkillList.length; i++) {
            if (this.SkillList[i].Selected)
                SkillIds.push(this.SkillList[i].Id)
        }
        this.SkillUpdate.emit(SkillIds);
        this.ModalRef.close();
    }
    //onKeyword(value: string): void {
    //    this.SkillList = this.shiftSetUp.skillList.filter((row) => {
    //        if (value == null || value.trim() == "") {
    //            return true;
    //        }
    //        let data = row.Name.toUpperCase();
    //        value = value.toLocaleUpperCase();
    //        return (data.indexOf(value) >= 0);
    //    })
    //}
}
